import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading font-bold text-foreground-950">
                  91<span className="text-primary-500">在线视频</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
                91在线视频官网 — 最新网址入口与APP下载页面。提供网红黑料吃瓜爆料内容，实时追踪热门事件，为你带来最新最全的娱乐资讯与独家爆料。
              </p>
              <p className="text-xs text-foreground-400 mt-3">
                本站内容仅供娱乐参考，请理性看待。
              </p>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-label font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-label font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/chigua-baoliao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    吃瓜爆料
                  </Link>
                </li>
                <li>
                  <Link to="/category/wanghong-heiliao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    网红黑料
                  </Link>
                </li>
                <li>
                  <Link to="/category/remen-shijian" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    热门事件
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-label font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
                关于
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    联系我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors" rel="nofollow">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-label font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
                关注我们
              </h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors" rel="nofollow" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors" rel="nofollow" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 91在线视频. 版权所有.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-700 transition-colors" rel="nofollow">服务条款</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors" rel="nofollow">隐私政策</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}